<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import Download from "$components/Download/Download.svelte";
  import { LogoUrbanWide } from "@urbaninstitute/dataviz-components";
  /** @typedef {import("svelte").Snippet} Snippet */

  /** @typedef {Object} Props
   * @property {Snippet} title
   * @property {Snippet} description
   * @property {import("svelte").Snippet<[boolean, () => void]>} [children]
   * @property {Snippet} source
   * @property {Snippet} notes
   * @property {string} downloadFilename
   * @property {string} downloadLabel
   * @property {string} [downloadId]
   */

  /** @type {Props} */
  let {
    title,
    description,
    children,
    source,
    notes,
    downloadFilename,
    downloadLabel,
    downloadId = "viz"
  } = $props();
</script>

{#snippet vizBody(/** @type {boolean} */ isDownload, /** @type {() => void} */ onready = () => {})}
  <div class="chart-container">
    <div class="chart-text">
      {@render title?.()}
      {@render description?.()}
    </div>
    {@render children?.(isDownload, onready)}
    {#if isDownload}
      <div class="chart-text">
        <div class="logo-container">
          <LogoUrbanWide width={175} />
        </div>
        {@render source?.()}
        {@render notes?.()}
      </div>
    {/if}
  </div>
{/snippet}
<div class="viz-wrapper">
  {@render vizBody(false)}
  <Download id={downloadId} filename={downloadFilename} label={downloadLabel}>
    {#snippet children(/** @type {() => void} */ onready)}
      {@render vizBody(true, onready)}
    {/snippet}
  </Download>
</div>

<style>
  .chart-container {
    margin-bottom: var(--spacing-8);
  }
  .logo-container {
    display: flex;
    justify-content: flex-end;
    margin-top: var(--spacing-4);
  }
  .chart-text:first-of-type {
    margin-bottom: var(--spacing-8);
  }
</style>
